import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthStore } from './auth.store';

/**
 * Rutas de administración (crear/editar comunicaciones, gestión, etc.).
 *
 * La API ya bloquea las operaciones con sus policies (403), pero sin este guard
 * un viticultor que escriba la URL a mano ve la pantalla completa de gestión y
 * solo descubre que no puede al guardar. Aquí se corta la navegación.
 */
export const adminGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const roles = authStore.user()?.roles ?? [];
  const isAdmin = roles.some((role) => {
    const name = role.toLowerCase();
    return name === 'admin' || name === 'superadmin';
  });

  if (isAdmin) {
    return true;
  }

  void router.navigateByUrl('/app/dashboard');

  return false;
};
